import colors from '../colors';

export const fontSize = {
	min: 10,
	tiny: 12,
	normal: 14,
	medium: 16,
	large: 18,
	huge: 20,
	king: 22,
	chartTitle: 30,
};

export const fontFamily = {
	primaryRegular: 'TTNormsPro-Regular',
	primaryMedium: 'TTNormsPro-Medium',
};

const typographyBase = {
	color: colors.white,
};

export const typography = {
	'screen-name': {
		...typographyBase,
		fontSize: '24px',
		fontFamily: fontFamily.primaryMedium,
	},
	primary: {
		...typographyBase,
		font: '400 18px/22px "TTNormsPro-Regular", sans-serif',
	},
	title: {
		...typographyBase,
		lineHeight: '40px',
	},
	button: {
		...typographyBase,
	},
	bold: {
		...typographyBase,
		lineHeight: '24px',
		font: '700 18px/22px "TTNormsPro-Regular", sans-serif',
		letterSpacing: '10',
	},
	king: {
		font: '700 22px/28px "TTNormsPro-Regular", sans-serif',
	},
	tableItem: {
		font: '400 14px/22px "TTNormsPro-Regular", sans-serif',
	},
};

const buttonBase = {
	padding: '14px 0',
	fontSize: fontSize.huge,
	alignItems: 'center',
	justifyContent: 'center',
	zIndex: 2,
	width: '100%',
};

export const buttons = {
	primary: {
		...buttonBase,
	},
	secondary: {
		...buttonBase,
		padding: '4px 20px',
	},
	outline: {
		...buttonBase,
		borderWidth: 2,
		borderColor: colors.white,
		backgroundColor: colors.white,
	},
	bordered: {
		...buttonBase,
		borderWidth: 1,
		borderColor: colors.white,
		backgroundColor: colors.white,
		marginBottom: 5,
		justifyContent: 'space-between',
		padding: '12px 5px',
	},
	add: {
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: 16,
	},
	link: {},
	underline: {},
	centerLink: {
		...buttonBase,
		backgroundColor: colors.white,
		justifyContent: 'center',
		padding: '12px 5px',
	},
};

const badgeBase = {
	backgroundColor: colors.white,
	padding: '7px 16px',
	borderRadius: 16,
	borderWidth: 2,
	borderColor: colors.white,
	label: {
		color: colors.white,
		fontSize: fontSize.tiny,
	},
};

export const badges = {
	primary: {
		...badgeBase,
	},
	active: {
		...badgeBase,
		backgroundColor: colors.white,
		borderWidth: 2,
		//   borderColor: colors.green,
		label: {
			...badgeBase.label,
			// color: colors.green,
		},
	},
};

export const inputs = {
	primary: {
		padding: '9px 0',
		fontSize: fontSize.medium,
	},
};

export const themeDefault = {
	colors,
	fontFamily,
	fontSize,
	typography,
	inputs,
	buttons,
	badges,
};
